export const getDisplayName = (aliasParam, primaryName, labelName) => {
    const display_process_name = aliasParam || primaryName;
    
    if (display_process_name !== labelName) {
        return `${display_process_name}, ${labelName}`;
    }
    return display_process_name;
};